export default "__VITE_ASSET__5f6e6b55__"